/* eslint-disable */

import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import router from './router/router'
import App from './App.vue'
import {
  store
} from './store/store'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueChartkick from 'vue-chartkick';
import Chart from 'chart.js';
import JsonExcel from 'vue-json-excel';

import Security from './libs/security/security';
import Translation from './libs/translation/translation-helper';
import ServiceCaller from './libs/service-caller/service-caller-vue';
import Loader from '@/components/common/modals/Loading';
import ErrorModal from '@/components/common/modals/ErrorModal';
import SuccessModal from '@/components/common/modals/SuccessModal';
import YesNoModal from '@/components/common/modals/YesNoModal';


//#region GET CONFIG & SETUP AXIOS SERVICE AUTH CALLER
var configURL = "config.json?" + new Date();

function fetchLocal(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest
    xhr.onload = function () {
      resolve(new Response(xhr.responseText));
    }
    xhr.onerror = function () {
      reject(new TypeError('Local request failed'))
    }
    xhr.open('GET', url)
    xhr.send(null)
  })
}

fetchLocal(configURL)
  .then(response => response.json()).then(data => {
    // First init config file then call this
    localStorage["Config"] = JSON.stringify(data);

    Vue.prototype.$Config = data;
    Vue.use(ServiceCaller, data, store);
    Vue.use(Security, store);
    Vue.use(VueChartkick, {
      adapter: Chart
    });

    Translation.Initialise().then(() => {
      Vue.use(Translation);
      Vue.component('Loader', Loader);
      Vue.component('ErrorModal', ErrorModal);
      Vue.component('SuccessModal', SuccessModal);
      Vue.component('YesNoModal', YesNoModal);
      Vue.component('downloadExcel', JsonExcel)

      new Vue({
        store,
        router,
        Vuetify,
        render: h => h(App),
      }).$mount('#app')
    })
  })
  .catch(error => {
    console.error(error)
  })
//#endregion

Vue.config.productionTip = false